export enum InventoryCountStatus {
  UNKNOWN = 0,
  OPEN = 1,
  CLOSED = 2,
}
